export default "__VITE_ASSET__DginjW1A__"